"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterProvider = RouterProvider;
exports.Router = Router;
exports.Link = Link;
exports.useRouter = useRouter;
exports.useTitle = useTitle;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var createHref = "http://localhost/";
var createPageKey = "default";
var createRouterContext = {
    index: 0,
    pages: [{ pageKey: createPageKey, href: createHref }],
    push: function () { },
    back: function () { },
    forward: function () { },
};
// SSR support. Designed to be loaded with render.
function getHref() {
    var _a, _b;
    if (!global.window)
        console.error("Error: No default location for SSR!");
    return ((_b = (_a = global.window) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.href) || createHref;
}
function getDefaultHistory() {
    return {
        index: 0,
        pages: [{ pageKey: createPageKey, href: getHref() }],
    };
}
var PageContext = (0, react_1.createContext)(getPageProps(createPageKey, createHref, 0, 0));
var RouterContext = (0, react_1.createContext)(createRouterContext);
function RouterProvider(_a) {
    var children = _a.children, onPageChange = _a.onPageChange, _b = _a.scrollSpeed, scrollSpeed = _b === void 0 ? 500 : _b, _c = _a.scrollAlways, scrollAlways = _c === void 0 ? false : _c, _d = _a.noScroll, noScroll = _d === void 0 ? false : _d;
    var _e = (0, react_1.useState)(getDefaultHistory()), history = _e[0], setHistory = _e[1];
    var pageActual = history.pages[history.index];
    (0, react_1.useEffect)(function () {
        if (onPageChange && (pageActual === null || pageActual === void 0 ? void 0 : pageActual.href))
            onPageChange(pageActual.href);
    }, [pageActual === null || pageActual === void 0 ? void 0 : pageActual.href]);
    var _f = (0, react_1.useMemo)(function () {
        var handleChange = function () {
            var newHref = window.location.href;
            setHistory(function (history) {
                var pageActual = history.pages[history.index];
                var pageBack = history.pages[history.index + 1];
                var pageForward = history.pages[history.index + 1];
                if (newHref === (pageActual === null || pageActual === void 0 ? void 0 : pageActual.href))
                    return history;
                !noScroll && scrollAlways && scrollToTop(scrollSpeed);
                if (newHref === (pageBack === null || pageBack === void 0 ? void 0 : pageBack.href)) {
                    return __assign(__assign({}, history), { index: history.index + 1 });
                }
                if (newHref === (pageForward === null || pageForward === void 0 ? void 0 : pageForward.href)) {
                    return __assign(__assign({}, history), { index: history.index - 1 });
                }
                // remove forwarded pages
                var pages = history.pages.slice(history.index);
                var newPage = {
                    pageKey: new Date().toISOString(),
                    href: newHref,
                };
                !noScroll && !scrollAlways && scrollToTop(scrollSpeed);
                return {
                    index: 0,
                    pages: __spreadArray([newPage], pages, true),
                };
            });
        };
        var push = function (to) {
            window.history.pushState({ to: to }, "", to);
            handleChange();
        };
        var back = function () {
            setHistory(function (history) {
                var index = history.index + 1;
                if (index >= history.pages.length) {
                    index = history.pages.length - 1;
                }
                !noScroll && scrollAlways && scrollToTop(scrollSpeed);
                return __assign(__assign({}, history), { index: index });
            });
        };
        var forward = function () {
            setHistory(function (history) {
                var index = history.index - 1;
                if (index < 0)
                    index = 0;
                !noScroll && scrollAlways && scrollToTop(scrollSpeed);
                return __assign(__assign({}, history), { index: index });
            });
        };
        return { handleChange: handleChange, push: push, back: back, forward: forward };
    }, [scrollSpeed, scrollAlways, noScroll]), handleChange = _f.handleChange, push = _f.push, back = _f.back, forward = _f.forward;
    (0, react_1.useEffect)(function () {
        window.addEventListener("popstate", handleChange);
        window.addEventListener("hashchange", handleChange);
        return function () {
            window.removeEventListener("popstate", handleChange);
            window.removeEventListener("hashchange", handleChange);
        };
    }, [handleChange]);
    // for useRouter outside Router
    var actualPageProps = getPageProps(pageActual.pageKey, pageActual.href, history.index, history.index);
    return (0, jsx_runtime_1.jsx)(RouterContext.Provider, { value: __assign(__assign({}, history), { push: push, back: back, forward: forward }), children: (0, jsx_runtime_1.jsx)(PageContext.Provider, { value: actualPageProps, children: children }) });
}
function Router(_a) {
    var renderPage = _a.renderPage, renderAnimation = _a.renderAnimation;
    var _b = (0, react_1.useContext)(RouterContext), index = _b.index, pages = _b.pages;
    var Page = renderPage;
    var Animation = renderAnimation;
    if (Animation) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: pages.map(function (page, i) {
                var pageProps = getPageProps(page.pageKey, page.href, i, index);
                return ((0, jsx_runtime_1.jsx)(PageContext.Provider, { value: pageProps, children: (0, jsx_runtime_1.jsx)(Animation, __assign({}, pageProps, { page: (0, jsx_runtime_1.jsx)(Page, __assign({}, pageProps)) })) }, page.pageKey));
            }).reverse() });
    }
    else {
        var activePage = pages[index];
        var pageProps = getPageProps(activePage.pageKey, activePage.href, index, index);
        return (0, jsx_runtime_1.jsx)(PageContext.Provider, { value: pageProps, children: (0, jsx_runtime_1.jsx)(Page, __assign({}, pageProps)) });
    }
}
function Link(_a) {
    var to = _a.to, _b = _a.className, className = _b === void 0 ? "" : _b, children = _a.children;
    var _c = (0, react_1.useContext)(RouterContext), index = _c.index, pages = _c.pages, push = _c.push;
    // do not use PageContext, Link can by outside of page
    var isActive = (0, react_1.useMemo)(function () {
        var pageActual = pages[index];
        if (!pageActual.href)
            return false;
        var url = new URL(pageActual.href);
        return url.pathname + url.search === to;
    }, [index, pages]);
    return (0, jsx_runtime_1.jsx)("a", { href: to, className: className + (isActive ? " active" : ""), onClick: function (e) {
            e.preventDefault();
            push(to);
        }, children: children });
}
function useRouter() {
    var _a = (0, react_1.useContext)(RouterContext), push = _a.push, back = _a.back, forward = _a.forward;
    var pageProps = (0, react_1.useContext)(PageContext);
    return __assign(__assign({}, pageProps), { push: push, back: back, forward: forward });
}
function useTitle(title) {
    var state = (0, react_1.useContext)(PageContext).state;
    (0, react_1.useEffect)(function () {
        if (state === "active") {
            document.title = title;
        }
    }, [state, title]);
}
function getPageProps(pageKey, href, index, actualIndex) {
    var url = new URL(href);
    var searchParams = {};
    url.searchParams.forEach(function (value, key) { return searchParams[key] = value; });
    return {
        pageKey: pageKey,
        href: href,
        to: url.pathname + url.search,
        path: url.pathname.split("/").map(function (p) { return decodeURIComponent(p); }).filter(Boolean),
        searchParams: searchParams,
        state: index === actualIndex
            ? "active"
            : index > actualIndex
                ? "back"
                : "forward",
    };
}
function scrollToTop(time, startScroll, startTime) {
    if (startScroll === void 0) { startScroll = window.scrollY; }
    if (startTime === void 0) { startTime = new Date().getTime(); }
    if (window.scrollY > 0) {
        var ratio = (new Date().getTime() - startTime) / time;
        window.scrollTo(0, startScroll * (1 - ratio));
        window.requestAnimationFrame(function () { return scrollToTop(time, startScroll, startTime); });
    }
}
